module.exports = __webpack_public_path__ + "static/media/35.51618049.jpg";